import React , {useState}from 'react'
import ReadyToLiveAds from './ReadyToLiveAds';
import AssignToDesignerAds from './AssignToDesignerAds';

const UnpickedAds = ({adCounts})=>{
    const [selectedTab, setSelectedTab] = useState('assign');
    return (
        <div>
          <div className="sticky flex gap-4 mb-4">
            <button
              className={`px-4 py-2 rounded ${selectedTab === 'assign' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
              onClick={() => setSelectedTab('assign')}
            >
              Assign to Designer ads <span className="text-black mx-1 py-1 px-2 bg-gray-200 rounded-full">{adCounts.unassigned}</span>
            </button>
            <button
              className={`px-4 py-2 rounded ${selectedTab === 'ready' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
              onClick={() => setSelectedTab('ready')}
            >
              Ready to live ads <span className="text-black mx-1 py-1 px-2 bg-white rounded-full">{adCounts.unpicked_ready_to_live}</span>
            </button>
          </div>
    
          {selectedTab === 'assign' ? (
            <AssignToDesignerAds/>
          ) : (
            <ReadyToLiveAds/>
          )}
        </div>
    )
}
export default UnpickedAds;